import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ApiResponse, BaseComponent, Contract, Customer, StoreService} from 'compob2b-libs';
import {map, takeUntil, tap} from 'rxjs/operators';

@Component({
    selector: 'app-modal-company',
    templateUrl: './modal-company.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
    :host {
      ul {
        list-style: none;
        padding: 0;
        margin: 0 10px;

        li {
          width: 100%;
          font-weight: normal;
          font-size: 16px;
          margin: 20px 0 0;
        }

        .selected {
          color: var(--color-primary);
        }

        a:hover {
          cursor: pointer;
          color: inherit;
        }

        small {
          padding:  5px 0 0 7px;
          color: var(--color-basic-600);
          display: block;
        }
      }
    }
  `],
    standalone: false
})
export class PopupCompanyComponent extends BaseComponent {
  keyword = '';
  filteredContracts: Contract[] = [];
  contracts: Contract[] = [];
  selected = 0;

  private readonly customer$ = this.storeService.getCustomerAsync();

  constructor(private readonly storeService: StoreService) {
    super();
    this.customer$.pipe(takeUntil(this.unsubscribe)).subscribe(customer => {
      this.filteredContracts = this.contracts = customer.contracts.filter(c => c.enabled);
      this.selected = customer.contractId;
    });
  }

  onKey($event: KeyboardEvent) {
    const regex = new RegExp(this.keyword, 'i');
    this.filteredContracts = this.contracts.filter(item => item.header.search(regex) !== -1);
  }

  select(contract: Contract) {
    this.compoApiService.patch<number, Customer>('/customer/set-default-contract', contract.id).pipe(
      takeUntil(this.unsubscribe),
      map((response: ApiResponse<Customer>) => response.data),
      tap(_ => this.storeService.nextCurrentContract(contract))
    ).subscribe((customer: Customer) => {
      this.storeService.nextCustomer(customer);
      window.location.reload();
    });
  }

}
